import * as React from "react";
import { PrismicPreviewProvider } from "gatsby-plugin-prismic-previews";

import { repositoryConfigs } from "./config/prismic/previews";

import "./src/normalize.css";
import "./src/style.css";

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>
    {element}
  </PrismicPreviewProvider>
);

// Configurazione Snipcart - caricata solo nel browser
export const onClientEntry = () => {
  // Aggiungi gli stili custom per z-index
  const customStyles = document.createElement("style");
  customStyles.innerHTML = `
    /* Assicuriamoci che il carrello Snipcart stia sopra a tutti gli elementi */
    #snipcart
   {
      z-index: 10000 !important;
      position: absolute;
    }

    
    /* Abbassiamo lo z-index della navbar per essere sicuri */
    nav {
      z-index: 100 !important;
    }
  `;
  document.head.appendChild(customStyles);

  // Script Snipcart con caricamento lazy
  const snipcartScript = document.createElement("script");


  snipcartScript.innerHTML = `
  
    window.SnipcartSettings = {
        publicApiKey: '${process.env.GATSBY_SNIPCART_API_KEY}',
        loadStrategy: 'on-user-interaction',
        productValidationUrl: '/api/products/'
    };

    (()=>{var c,d;(d=(c=window.SnipcartSettings).version)!=null||(c.version="3.0");var s,S;(S=(s=window.SnipcartSettings).timeoutDuration)!=null||(s.timeoutDuration=2750);var l,p;(p=(l=window.SnipcartSettings).domain)!=null||(l.domain="cdn.snipcart.com");var w,u;(u=(w=window.SnipcartSettings).protocol)!=null||(w.protocol="https");var f=window.SnipcartSettings.version.includes("v3.0.0-ci")||window.SnipcartSettings.version!="3.0"&&window.SnipcartSettings.version.localeCompare("3.4.0",void 0,{numeric:!0,sensitivity:"base"})===-1,m=["focus","mouseover","touchmove","scroll","keydown"];window.LoadSnipcart=o;document.readyState==="loading"?document.addEventListener("DOMContentLoaded",r):r();function r(){window.SnipcartSettings.loadStrategy?window.SnipcartSettings.loadStrategy==="on-user-interaction"&&(m.forEach(t=>document.addEventListener(t,o)),setTimeout(o,window.SnipcartSettings.timeoutDuration)):o()}var a=!1;function o(){if(a)return;a=!0;let t=document.getElementsByTagName("head")[0],e=document.querySelector("#snipcart"),i=document.querySelector(\`src[src^="\${window.SnipcartSettings.protocol}://\${window.SnipcartSettings.domain}"][src$="snipcart.js"]\`),n=document.querySelector(\`link[href^="\${window.SnipcartSettings.protocol}://\${window.SnipcartSettings.domain}"][href$="snipcart.css"]\`);e||(e=document.createElement("div"),e.id="snipcart",e.setAttribute("hidden","true"),document.body.appendChild(e)),v(e),i||(i=document.createElement("script"),i.src=\`\${window.SnipcartSettings.protocol}://\${window.SnipcartSettings.domain}/themes/v\${window.SnipcartSettings.version}/default/snipcart.js\`,i.async=!0,t.appendChild(i)),n||(n=document.createElement("link"),n.rel="stylesheet",n.type="text/css",n.href=\`\${window.SnipcartSettings.protocol}://\${window.SnipcartSettings.domain}/themes/v\${window.SnipcartSettings.version}/default/snipcart.css\`,t.prepend(n)),m.forEach(g=>document.removeEventListener(g,o))}function v(t){!f||(t.dataset.apiKey=window.SnipcartSettings.publicApiKey,window.SnipcartSettings.addProductBehavior&&(t.dataset.configAddProductBehavior=window.SnipcartSettings.addProductBehavior),window.SnipcartSettings.modalStyle&&(t.dataset.configModalStyle=window.SnipcartSettings.modalStyle),window.SnipcartSettings.currency&&(t.dataset.currency=window.SnipcartSettings.currency),window.SnipcartSettings.templatesUrl&&(t.dataset.templatesUrl=window.SnipcartSettings.templatesUrl))}})();
  `;
  document.head.appendChild(snipcartScript);

  // Configura la traduzione italiana quando Snipcart è pronto
  const l10nScript = document.createElement("script");

  l10nScript.innerHTML = `
document.addEventListener('snipcart.ready', function() {
  // Localizzazione italiana
  if (window.Snipcart && window.Snipcart.api) {
    Snipcart.api.session.setLanguage('it', {
      cart: { summary: "Riepilogo ordine" },
      header: { title_cart_summary: "Riepilogo carrello" }
    });
  }
});
`;
  document.body.appendChild(l10nScript);
};
